/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
import Vue from 'vue';
import api from '../api/index.js';
var Api = new api();
export var change = function change(_ref, item) {
  var commit = _ref.commit;
  commit('CHANGE', item);
};
export var classify = function classify(_ref2, item) {
  var commit = _ref2.commit;
  commit('CLASSIFY', item);
};
export var headerName = function headerName(_ref3, item) {
  var commit = _ref3.commit;

  if (!item) {
    commit('HEADERNAME', '医学V视界');
  } else {
    commit('HEADERNAME', item);
  }
};
export var courseVideUrl = function courseVideUrl(_ref4, item) {
  var commit = _ref4.commit;
  commit('CVU', item);
};
export var wxUserInfoAction = function wxUserInfoAction(_ref5, item) {
  var commit = _ref5.commit;
  Api.setStorage('wxUserInfo', item);
  Api.setUserId(item.id || '');
  commit('WXUSERINFO', item);
};
export var flowerCount = function flowerCount(_ref6, item) {
  var commit = _ref6.commit;
  commit('FLOWERCOUNT', item);
};
export var loadingCoverAction = function loadingCoverAction(_ref7, item) {
  var commit = _ref7.commit;
  commit('CHANGE', false);
  commit('LOADINGCOVER', item);
};